import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-profile-subscription-card',
  templateUrl: './profile-subscription-card.component.html',
  styleUrls: ['./profile-subscription-card.component.css']
})
export class ProfileSubscriptionCardComponent {

  @Input() isMyPlan: boolean = false;

}
